export default __webpack_public_path__ + "static/PromptIconFour-13e2d0798600e1370481ea1178762160.png";